module.exports = __webpack_public_path__ + "img/utilityheavy_parked.6d5c75d9.svg";